import { useEffect } from 'react';
import { faPalette as faPaletteLight } from '@fortawesome/pro-light-svg-icons';
import { faGears, faPalette } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { UpdateLookAndFeelSettingsForm } from '~/components/forms/LookAndFeelSettingsForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { useAppPreviewDispatch } from '~/components/organisms/AppPreview';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppLookAndFeelSettingsPageProps = {
  appId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppLookAndFeelSettingsPage: React.FC<
  IAppLookAndFeelSettingsPageProps
> = (props) => {
  const { appId, nextUrl, cancelUrl } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const appPreviewDispatch = useAppPreviewDispatch();
  const parentUrl = `/apps/${appId}/settings`;

  useEffect(() => {
    appPreviewDispatch.navigateToRoute({
      appId,
      path: '/',
      tab: 'today',
    });
  }, [appPreviewDispatch, appId]);

  return (
    <>
      <Helmet>
        <title>{t('AppLookAndFeelSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Text current>
          <FontAwesomeIcon icon={faPalette} />
          {t('AppLookAndFeelSettingsPage.title')}
        </Breadcrumbs.Text>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faPaletteLight} />}
        title={t('AppLookAndFeelSettingsPage.title')}
        subtitle={t('AppLookAndFeelSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />

      <UpdateLookAndFeelSettingsForm
        appId={appId}
        onSuccess={nextUrl ? () => navigate(nextUrl) : undefined}
        cancelUrl={cancelUrl ?? parentUrl}
      />
    </>
  );
};
